import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import { Wrapper, ColorButton } from './styles';
import ColorPicker from '../ColorPicker';
import { changeThemeColor } from '../../../../../containers/Editor/actions';

interface ColorsListProps {
	themeId: string;
	colors: string[];
	dispatch: Dispatch<StoreState>;
}

const ColorsList = ({ themeId, colors, dispatch }: ColorsListProps) => {
	const [activeColorIndex, setActiveColorIndex] = React.useState<number | null>(null);

	const handleColorButtonClick = (index: number) => {
		setActiveColorIndex(index);
	};

	const handleColorPickerConfirm = (color: string) => {
		const colorIndex = activeColorIndex as number;

		if (color !== colors[colorIndex]) {
			dispatch(changeThemeColor(themeId, colorIndex, color));
		}

		setActiveColorIndex(null);
	};

	const handleColorPickerCancel = () => {
		setActiveColorIndex(null);
	};

	return (
		<Wrapper>
			{colors.map((color, index) => (
				<ColorButton
					key={index}
					color={color}
					onClick={() => handleColorButtonClick(index)}
				/>
			))}
			{activeColorIndex !== null &&
				<ColorPicker
					initialColor={colors[activeColorIndex]}
					onConfirm={handleColorPickerConfirm}
					onCancel={handleColorPickerCancel}
				/>
			}
		</Wrapper>
	);
};

export default ColorsList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/ColorsList/index.tsx